if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.dialog = this.querySelector('[role="dialog"]');
    }

    hide(preventFocus = false) {
      this.dialog.classList.remove("slideIn");
      setTimeout(()=>{  
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
  
        if (preventFocus) this.openedBy = null;
        super.hide();
      }, 300)
    }

    show(opener, productChangeUrl) {
      if (!productChangeUrl) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }

      fetch(productChangeUrl ? productChangeUrl : opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          super.show(opener);
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          responseHTML.querySelectorAll('[loading="lazy"]').forEach(element => {
            element.removeAttribute('loading');
          });
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          
        })
        .finally(() => {
          setTimeout(() => {
          if (!productChangeUrl) {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
          

            if (window.matchMedia('(max-width: 990px)').matches) {

              const imageContainer = this.modalContent.querySelector(".quick-add-modal .product__media-wrapper");
              const infoContainer = this.modalContent.querySelector(".quick-add-modal .product__info-container");
              const title = this.modalContent.querySelector(".quick-add-modal .product__title");
              
              infoContainer.insertBefore(imageContainer, title);
              
              const quickViewGallery = this.modalContent.querySelector(".quick-add-modal .product__media-list");
              new Flickity( quickViewGallery, {
                  cellAlign: 'left',
                  imagesLoaded: false,
                  contain: true,
      		    wrapAround: true,
      			prevNextButtons:true,
                  arrowShape:"M24.42,99.16a2.84,2.84,0,0,0,2,.84,2.74,2.74,0,0,0,2-.84L75.58,52a2.81,2.81,0,0,0,0-4L28.42.83a2.83,2.83,0,1,0-4,4L69.58,50,24.42,95.16A2.82,2.82,0,0,0,24.42,99.16Z",
                });
              
    
    			var tapArea, startX ;
                tapArea = document.querySelectorAll(".quick-add-modal .product__media-list");
                startX = 0;
                for (var item of tapArea) {
                    item.ontouchstart = function(e) {
                        startX = e.touches[0].clientX;
                    };
                    item.ontouchmove = function(e) {
                        if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
                            e.preventDefault();
                        } 
                    };
                };
                const firstImage = this.modalContent.querySelector(".quick-add-modal .product__media.media");
                const sliderDots = this.modalContent.querySelector(".quick-add-modal .flickity-page-dots");
                const slideshowContainer = this.modalContent.querySelector(".quick-add-modal .product__media-list");
                const distanceSliderDots = firstImage.offsetHeight - 40;
                sliderDots.style.top = `${distanceSliderDots}px`;
                slideshowContainer.style.maxHeight = `${firstImage.offsetHeight}px`;

              } else {
                const lastImage = this.modalContent.querySelector(".quick-add-modal .product__media-list .product__media-item:last-child");
                const quickViewImageContainer = this.modalContent.querySelector(".quick-add-modal #carousel ul");
                quickViewImageContainer.style.marginBottom = `-${lastImage.offsetHeight}px`;
              }
            }, "100");
            if (typeof Tooltip != undefined) {
                var tooltip = new Tooltip({
                theme: "dark", // Selects one of the pre-defined tooltip styles - light or dark.
                distance: 10,    // Specifies the distance in pixels from trigger to tooltip.
                delay: 0        // Specifies how long the tooltip remains visible (in ms) after the mouse leaves the trigger.
              });
            }
            const colorVariants = this.modalContent.querySelectorAll(".product-alt-color a");
            const colorVariantArray = [...colorVariants];

            colorVariantArray.forEach(colorVariant => {
              colorVariant.addEventListener("click", (e) => {
                e.preventDefault();
                  this.modalContent.style.opacity = 0;
                this.show(undefined, colorVariant.getAttribute("href"));
              })
            });
            if (productChangeUrl) {
              setTimeout(()=>{
                this.modalContent.style.opacity = 1;
              },100)
            }
            console.log("add class");
            setTimeout(()=>{
              this.dialog.classList.add("slideIn");
            },200);
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        var newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      if (this.modalContent.querySelector('variant-radios,variant-selects') !== null ) {
        this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false'); 
      }
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
